import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/branch.actions'
import { MultiSelect } from 'primereact/multiselect'

class Branches extends PureComponent {
    render() {
        return (
            <MultiSelect
                value={this.props.selectedBranches || []}
                options={this.props.branches}
                onChange={(e) => this.props.handleChange(e.value)}
                placeholder="Select branches"
                filter
                className="w-full"
                maxSelectedLabels={3}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        branches: state.BranchReducer.branchList,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Branches)
